import React from 'react';
import { useProducts } from '../../context/ProductsContext';
import { ProductCard } from '../common/ProductCard';
import { Product } from '../../types/store';
import { ArrowRight, Pill } from 'lucide-react';

interface SupplementsSectionProps {
  onSelectProduct: (product: Product) => void;
  onViewAll: () => void;
}

export const SupplementsSection: React.FC<SupplementsSectionProps> = ({
  onSelectProduct,
  onViewAll,
}) => {
  const { products } = useProducts();
  const supplementProducts = products.filter((p) => p.category === 'Supplements');

  return (
    <section id="supplements-section" className="py-10 sm:py-14 bg-white">
      <div className="max-w-[1536px] mx-auto px-4 sm:px-6 lg:px-10">
        
        {/* Section Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 sm:mb-10 pb-4 border-b border-slate-100">
          <div>
            <div className="flex items-center gap-1.5 text-xs font-extrabold uppercase tracking-widest text-[#191975] mb-1">
              <Pill className="w-3.5 h-3.5 text-[#191975]" />
              <span>Nutrition & Health Range</span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-extrabold text-[#172554] tracking-tight">
              Supplements
            </h2>
            <p className="text-xs sm:text-sm text-[#64748B] mt-1">
              Formulated with high-potency vitamins and minerals to nourish active bodies and growing minds.
            </p>
          </div>

          <button
            id="supplements-view-all-btn"
            onClick={onViewAll}
            className="self-start sm:self-auto inline-flex items-center gap-2 bg-[#191975] hover:bg-[#14145c] text-white text-xs font-extrabold px-5 py-2.5 rounded-xl uppercase tracking-wider transition-colors shadow-xs"
          >
            <span>VIEW ALL</span>
            <ArrowRight className="w-3.5 h-3.5" />
          </button>
        </div>

        {/* 4 Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
          {supplementProducts.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onSelectProduct={onSelectProduct}
            />
          ))}
        </div>

      </div>
    </section>
  );
};
